import Type4 from "./option";

export default Type4;
